export const formatPriceUnitAppend = (price: number): string => Intl
  .NumberFormat('de-DE', { style: 'currency', currency: 'EUR' })
  .format(price / 100);

export const formatPriceUnitPrepend = (price: number): string => {
  if (price === 0) {
    return '€ 0,00';
  }

  return `€ ${Intl
    .NumberFormat('de-DE')
    .format(price / 100)}`;
};
